import { useState } from "react";
import { FaEarthAmericas } from "react-icons/fa6";
import { IoIosJournal } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { CiBitcoin } from "react-icons/ci";
import { RiMentalHealthLine } from "react-icons/ri";
import { MdOutlineHealthAndSafety } from "react-icons/md";
import {
  MdOutlineBook,
  MdOutlinePeople,
  MdOutlineFoodBank,
} from "react-icons/md";
import { SiSpringboot } from "react-icons/si";
import { TbFileTypePdf } from "react-icons/tb";
import { MdRateReview } from "react-icons/md";
import ImageCarousel from "./ImageCarousel";

const Projects = () => {
  const navigate = useNavigate();
  const [carouselOpen, setCarouselOpen] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const handleImageClick = (e, projectIndex, imageIndex) => {
    e.preventDefault();
    e.stopPropagation();
    setCarouselOpen(projectIndex);
    setSelectedImageIndex(imageIndex);
  };

  const handleCloseCarousel = () => {
    setCarouselOpen(null);
    setSelectedImageIndex(0);
  };

  const projects = [
    {
      title: "Microservices Ecommerce Platform",
      description:
        "Architected distributed e-commerce system with 2+ microservices using Java Spring Boot and Docker, deployed on AWS ECS.",
      tags: ["Java", "Spring Boot", "AWS", "Docker"],
      images: [],
      github: "https://github.com/alifhakimiazwan/microservices-ecommerce",
      icon: <SiSpringboot />,
    },
    {
      title: "Rate My University",
      description:
        "Elective subject rating platform for UKM students with 500+ visitors and 100+ reviews. Built with NextJS, React, and MongoDB.",
      tags: ["NextJS", "MongoDB", "AWS S3"],
      images: ["/assets/rmc1.png", "/assets/rmc2.png", "/assets/rmc3.png"],
      github: "https://github.com/alifhakimiazwan/RateMyUniversity",
      website: "https://ratemyuni.my/",
      icon: <MdRateReview />,
    },
    {
      title: "Chat With PDF",
      description:
        "Study tool leveraging NLP for interactive Q&A with PDF documents. Implemented text extraction and context-aware querying.",
      tags: ["NextJS", "LLM", "PostgreSQL"],
      images: ["/assets/cwp1.png", "/assets/cwp2.png", "/assets/cwp3.png"],
      github: "https://github.com/alifhakimiazwan/Chat-With-PDF",
      icon: <TbFileTypePdf />,
    },
  ];

  return (
    <div className="mt-16 sm:mt-20 md:mt-32 px-4 sm:px-6 md:px-0">
      <h1 className="text-2xl sm:text-3xl md:text-4xl">Projects</h1>
      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-2">
        {projects.map((project, index) => (
          <a
            key={index}
            href={project.github}
            target="_blank"
            className="p-4 sm:p-5 m-2 flex flex-col items-start bg-gray-50 rounded-3xl cursor-pointer hover:bg-gray-100 text-left hover:scale-105 duration-300"
          >
            <div size="40" color="E0E6EB" className="go1550876186">
              <span
                name="Shape35"
                color="2D3A46"
                size="20"
                role="img"
                className="go2599496350 text-2xl"
              >
                {project.icon}
              </span>
            </div>
            <h3 className="text-xl sm:text-2xl mt-3 sm:mt-4 font-medium">
              {project.title}
            </h3>
            <p className="mt-2 opacity-50 font-light text-sm sm:text-base">
              {project.description}
            </p>
            <div className="flex flex-wrap gap-2 mt-3 sm:mt-4">
              {project.tags.map((tag, idx) => (
                <span
                  key={idx}
                  className="text-xs sm:text-sm py-1 px-3 sm:py-2 sm:px-4 bg-gray-200 rounded-3xl"
                >
                  {tag}
                </span>
              ))}
            </div>

            {/* Image Grid */}
            {project.images.length > 0 && (
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 mt-3 sm:mt-4 w-full">
                {project.images.map((image, imgIndex) => (
                  <img
                    key={imgIndex}
                    src={image}
                    alt={`${project.title} ${imgIndex + 1}`}
                    className="rounded-lg w-full cursor-pointer hover:opacity-80 transition-opacity duration-200"
                    onClick={(e) => handleImageClick(e, index, imgIndex)}
                  />
                ))}
              </div>
            )}
          </a>
        ))}
      </div>

      {/* Carousel Modal */}
      {carouselOpen !== null && projects[carouselOpen].images.length > 0 && (
        <ImageCarousel
          images={projects[carouselOpen].images}
          initialIndex={selectedImageIndex}
          onClose={handleCloseCarousel}
          projectTitle={projects[carouselOpen].title}
        />
      )}

      <div className="flex flex-col items-center w-full">
        <div className="relative z-10 text-black flex flex-col items-center rounded-xl w-32 sm:w-36 bg-white r shadow-lg shadow-sky-500 mt-4">
          <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
          <button
            onClick={() => navigate("/projects")}
            class="relative gradient-border px-3 py-2 sm:px-4 sm:py-2 rounded-xl justify-between bg-black hover:bg-white hover:text-black opacity-95 hover:opacity-100 text-white w-full text-sm sm:text-base font-normal transform hover:scale-105 duration-300"
          >
            See more
          </button>
        </div>
      </div>
    </div>
  );
};

export default Projects;
